import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from '../style'

export const Success = props => (
  <Row>
    <Col>
      <h3 className={css(style.headers.h3)}>Your message has been sent!</h3>
      <p className={css(style.paragraphs.p)}>
        You should receive a response in no later than one business day.
      </p>
    </Col>
  </Row>
)

export default Success



// WEBPACK FOOTER //
// ./src/components/Contact/partials/Success.js